import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// ===========================================
// 決済リンク情報
// ===========================================

export interface CheckoutLinkInfo {
  link_id: number;
  tenant: {
    code: string;
    name: string;
    branding: {
      logo_url: string | null;
      primary_color: string;
      brand_name: string;
      support_email: string;
    };
  };
  product: {
    id: number;
    code: string;
    name: string;
    description: string | null;
    image_url: string | null;
  };
  plan: {
    code: string;
    name: string;
    features: string[];
  };
  price: number;
  is_free: boolean;
  currency: string;
}

export const getCheckoutLinkInfo = async (slug: string): Promise<CheckoutLinkInfo> => {
  const response = await api.get<CheckoutLinkInfo>(`/oem/checkout/link/${slug}`);
  return response.data;
};

// ===========================================
// チェックアウトセッション作成
// ===========================================

export interface CheckoutSessionRequest {
  payment_link_id: number;
  email: string;
  success_url: string;
  cancel_url: string;
}

export interface CheckoutSessionResponse {
  session_id: string;
  checkout_url: string;
  expires_at: number;
}

export const createCheckoutSession = async (
  request: CheckoutSessionRequest
): Promise<CheckoutSessionResponse> => {
  const response = await api.post<CheckoutSessionResponse>('/oem/checkout/session', request);
  return response.data;
};

// ===========================================
// 無料プラン登録
// ===========================================

export interface FreeRegistrationRequest {
  payment_link_id: number;
  email: string;
  full_name?: string;
}

export interface FreeRegistrationResponse {
  success: boolean;
  user_id: number;
  message: string;
}

export const registerFreePlan = async (
  request: FreeRegistrationRequest
): Promise<FreeRegistrationResponse> => {
  const response = await api.post<FreeRegistrationResponse>('/oem/checkout/free', request);
  return response.data;
};
